export default {"src":"/_next/static/media/link.eceb4f04.svg","height":32,"width":32};